import Link from "next/link";

export function SiteLogo() {
  return (
    <Link href="/" className="flex items-center gap-3 group">
      {/* 科技感 Logo 图标 */}
      <div className="relative w-10 h-10 flex-shrink-0">
        {/* 外层六边形框架 */}
        <svg 
          viewBox="0 0 40 40" 
          className="absolute inset-0 w-full h-full"
        >
          <defs>
            <linearGradient id="logoGrad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#06b6d4" />
              <stop offset="50%" stopColor="#3b82f6" />
              <stop offset="100%" stopColor="#8b5cf6" />
            </linearGradient>
            <filter id="glow">
              <feGaussianBlur stdDeviation="1.5" result="coloredBlur"/>
              <feMerge>
                <feMergeNode in="coloredBlur"/>
                <feMergeNode in="SourceGraphic"/>
              </feMerge>
            </filter>
          </defs>
          
          {/* 六边形外框 */}
          <polygon 
            points="20,2 37,11 37,29 20,38 3,29 3,11" 
            fill="none" 
            stroke="url(#logoGrad)" 
            strokeWidth="1.5"
            filter="url(#glow)"
            className="group-hover:stroke-[2] transition-all duration-300"
          />
          
          {/* 内层六边形 */}
          <polygon 
            points="20,8 32,14.5 32,25.5 20,32 8,25.5 8,14.5" 
            fill="url(#logoGrad)" 
            fillOpacity="0.15"
            className="group-hover:fill-opacity-25 transition-all duration-300"
          />
          
          {/* 中心节点 */}
          <circle cx="20" cy="20" r="3" fill="url(#logoGrad)" className="animate-pulse" />
          
          {/* 连接线 - 上 */}
          <line x1="20" y1="14" x2="20" y2="8" stroke="url(#logoGrad)" strokeWidth="1" strokeOpacity="0.6" />
          {/* 连接线 - 下 */}
          <line x1="20" y1="26" x2="20" y2="32" stroke="url(#logoGrad)" strokeWidth="1" strokeOpacity="0.6" />
          {/* 连接线 - 左 */}
          <line x1="14" y1="17" x2="8" y2="14.5" stroke="url(#logoGrad)" strokeWidth="1" strokeOpacity="0.6" />
          {/* 连接线 - 右 */}
          <line x1="26" y1="17" x2="32" y2="14.5" stroke="url(#logoGrad)" strokeWidth="1" strokeOpacity="0.6" />
          
          {/* 角落装饰点 */}
          <circle cx="20" cy="8" r="1.5" fill="#06b6d4" className="group-hover:r-2 transition-all" />
          <circle cx="32" cy="14.5" r="1.5" fill="#3b82f6" />
          <circle cx="32" cy="25.5" r="1.5" fill="#6366f1" />
          <circle cx="20" cy="32" r="1.5" fill="#8b5cf6" />
          <circle cx="8" cy="25.5" r="1.5" fill="#6366f1" />
          <circle cx="8" cy="14.5" r="1.5" fill="#3b82f6" />
        </svg>
        
        {/* 扫描线效果 */}
        <div className="absolute inset-0 overflow-hidden rounded-lg">
          <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
            <div className="absolute inset-0 animate-scan bg-gradient-to-b from-transparent via-cyan-500/20 to-transparent" />
          </div>
        </div>
      </div>
      
      {/* Logo 文字 */}
      <div className="flex flex-col">
        <div className="flex items-baseline gap-1">
          <span className="text-white font-bold text-base leading-tight tracking-wide group-hover:text-cyan-300 transition-colors duration-300">
            算法组织
          </span>
          <span className="text-xs text-gray-500 tracking-[0.2em] group-hover:text-cyan-500/70 transition-colors duration-300">
            LAB
          </span>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-[10px] text-gray-600 tracking-wider group-hover:text-gray-500 transition-colors duration-300">
            ALGORITHM ORG
          </span>
          <div className="w-8 h-px bg-gradient-to-r from-cyan-500/50 to-transparent" />
        </div>
      </div>
      
      {/* 装饰性数据流 */}
      <style>{`
        @keyframes scan {
          0% { transform: translateY(-100%); }
          100% { transform: translateY(100%); }
        }
        .animate-scan {
          animation: scan 1.5s ease-in-out infinite;
        }
      `}</style>
    </Link>
  );
}
